export enum DateStatus {
  READY = 'ready',
  PROGRESS = 'progress',
  TODO = 'todo'
}
